export default {
  // Titoli pagina
  pageTitle: 'Impostazioni Evento | WedBox',
  settingsTitle: 'Impostazioni Evento',
  settingsDescription: 'Gestisci i dettagli del tuo evento',
  
  // Campi base esistenti
  title: "I miei eventi",
  myEvents: "I miei eventi",
  description: "Crea e gestisci i tuoi eventi",
  createEvent: "Crea evento",
  createNew: "Crea nuovo",
  currentEvent: "Evento attuale",
  noEvents: "Nessun evento",
  addFirstEvent: "Crea il tuo primo evento",
  createFirstEvent: "Crea il tuo primo evento",
  eventCreated: "Evento creato con successo",
  eventUpdated: "Evento aggiornato",
  eventDeleted: "Evento eliminato",
  selectEventType: "Seleziona tipo di evento",
  date: "Data",
  location: "Luogo",
  guestCount: "Numero ospiti",
  budget: "Budget",
  status: "Stato",
  active: "Attivo",
  draft: "Bozza",
  completed: "Completato",
  cancelled: "Annullato",
  editEvent: "Modifica Evento",
  deleteEvent: "Elimina Evento",
  confirmDelete: "Sei sicuro di voler eliminare questo evento?",
  yes: "Sì",
  no: "No",
  save: "Salva",
  cancel: "Annulla",
  close: "Chiudi",
  switch: "Cambia",
  switchEvent: "Cambia Evento",
  switchedTo: "Passato a",
  currentlyActive: "Attualmente attivo",
  searchEvents: "Cerca eventi",
  noEventsFound: "Nessun evento trovato",
  manage: "Gestisci",
  yourEvents: "I tuoi eventi",
  advancedView: "Vista Avanzata",
  basicView: "Vista Base",

  // Azioni di massa
  bulkActions: {
    title: "Azioni di Massa",
    selectAll: "Seleziona Tutto",
    selected: "selezionato/i",
    delete: "Elimina",
    archive: "Archivia",
    export: "Esporta",
    duplicate: "Duplica",
    processing: "Elaborazione...",
    confirmDelete: "Sei sicuro di voler eliminare gli eventi selezionati?",
    description: "Gestisci più eventi contemporaneamente"
  },

  // Info abbonamento
  subscriptionInfo: {
    free: {
      title: "Piano Gratuito",
      description: "Ottimo per iniziare"
    },
    essential: {
      title: "Piano Essential",
      description: "Per piccoli eventi"
    },
    pro: {
      title: "Piano Pro",
      description: "Per grandi eventi"
    }
  },

  dashboard: {
    subtitle: "Panoramica",
    title: "Dashboard eventi",
    usage: "Utilizzo",
    gridView: "Griglia",
    listView: "Lista"
  },

  maxEventsReached: "Numero massimo di eventi raggiunto",
  upgradeToCreateMoreEvents: "Aggiorna per creare più eventi",

  // Tipi di evento
  eventTypes: {
    wedding: "Matrimonio",
    engagement: "Fidanzamento",
    birthday: "Compleanno",
    babyShower: "Baby Shower",
    baptism: "Battesimo",
    reunion: "Riunione",
    corporate: "Evento Aziendale",
    other: "Altro",
    WEDDING: "Matrimonio",
    PACS: "Unione civile",
    pacs: "Unione civile",
    ANNIVERSARY: "Anniversario",
    anniversary: "Anniversario",
    CORPORATE: "Evento aziendale",
    OTHER: "Altro",
    BABYSHOWER: "Baby shower",
    BAPTISM: "Battesimo"
  },

  // Sezioni modulo
  form: {
    eventDetails: "Dettagli Evento",
    basicInfo: "Informazioni Base",
    eventName: "Nome Evento",
    eventType: "Tipo Evento",
    eventDate: "Data Evento",
    eventLocation: "Luogo Evento",
    partners: "Partner / Persone Principali",
    partner1: "Partner 1 / Persona Principale", 
    partner2: "Partner 2 (opzionale)",
    firstName: "Nome",
    lastName: "Cognome",
    placeholders: {
      eventName: 'Es: Matrimonio di Maria e Pietro',
      eventLocation: 'Es: Reggia di Versailles, Parigi',
      firstName: 'Nome',
      lastName: 'Cognome',
    },
  },

  // Azioni
  actions: {
    create: "Crea",
    edit: "Modifica",
    delete: "Elimina",
    duplicate: "Duplica",
    share: "Condividi",
    setDefault: "Imposta come Predefinito",
    selectEvent: "Seleziona Evento",
  },

  // Formattazione data
  dateFormat: {
    notSpecified: 'Non specificata',
    invalid: 'Data non valida',
  },

  // Dettagli scheda
  details: {
    title: 'Dettagli Evento',
    id: 'ID:',
    eventCount: '{{count}} eventi totali',
    singleEvent: '1 evento',
  },

  // Stato vuoto
  empty: {
    noEventSelected: 'Nessun evento selezionato',
    selectEventDescription: 'Seleziona un evento per accedere alle sue impostazioni.',
  },

  // Messaggi di successo
  success: {
    title: 'Successo',
    eventUpdated: 'Evento aggiornato con successo',
  },

  // Messaggi di errore
  errors: {
    title: 'Errore',
    updateFailed: 'Impossibile aggiornare l\'evento',
    updateError: 'Errore durante l\'aggiornamento',
    deleteFailed: 'Impossibile eliminare l\'evento',
    deleteError: 'Errore durante l\'eliminazione',
  },

  // Conferma eliminazione
  deleteConfirmation: {
    title: 'Elimina Evento',
    description: 'Sei sicuro di voler eliminare l\'evento "{{eventName}}"? Questa azione è irreversibile e tutti i dati associati saranno eliminati.',
    confirm: 'Elimina',
    cancel: 'Annulla',
  },

  deleteConfirmationModal: {
    title: 'Elimina Evento',
    description: 'Sei sicuro di voler eliminare l\'evento "{{eventName}}"? Questa azione è irreversibile e tutti i dati associati saranno eliminati.',
    confirm: 'Elimina',
    cancel: 'Annulla',
  },

  // Funzionalità esistenti
  features: {
    aiAssistant: 'Assistente IA',
    aiAssistantDesc: 'Ottieni suggerimenti personalizzati e aiuto intelligente.',
    taskManagement: 'Gestione Attività',
    taskManagementDesc: 'Organizza e traccia tutte le attività del tuo evento.',
    budgetPlanning: 'Pianificazione Budget',
    budgetPlanningDesc: 'Gestisci il tuo budget con strumenti di tracciamento dettagliati.',
    guestManagement: 'Gestione Ospiti',
    guestManagementDesc: 'Organizza la tua lista ospiti e le loro risposte.',
    vendorCoordination: 'Coordinamento Fornitori',
    vendorCoordinationDesc: 'Trova e gestisci facilmente i tuoi fornitori.',
    timelineTracking: 'Tracciamento Cronologia',
    timelineTrackingDesc: 'Visualizza e pianifica la cronologia del tuo evento.',
    collaborativeTools: 'Strumenti Collaborativi',
    collaborativeToolsDesc: 'Lavora insieme al tuo team e ai tuoi cari.',
    documentSharing: 'Condivisione Documenti',
    documentSharingDesc: 'Condividi e organizza tutti i tuoi documenti importanti.',
    mobileSynchronization: 'Sincronizzazione Mobile',
    mobileSynchronizationDesc: 'Accedi ai tuoi dati ovunque con la sincronizzazione cloud.',
    customTemplates: 'Modelli Personalizzati',
    customTemplatesDesc: 'Crea e usa modelli adattati alle tue esigenze.',
    realTimeNotifications: 'Notifiche in Tempo Reale',
    realTimeNotificationsDesc: 'Rimani informato sugli aggiornamenti importanti.',
    advancedReporting: 'Reportistica Avanzata',
    advancedReportingDesc: 'Analizza i tuoi dati con report dettagliati.',
    duplicateDetection: 'Rilevamento Duplicati',
    duplicateDetectionDesc: 'Identifica eventi simili in base a nome, tipo e data.'
  },

  // Traduzioni pagina test
  testPage: {
    title: "🧪 Pagina Test Funzioni Firebase",
    firebaseTest: {
      title: "Test Funzione Firebase",
      description: "Testa la connettività con le funzioni Firebase prima di tentare l'eliminazione dell'account.",
      button: "Testa Funzione Firebase",
      result: "Risultato",
      userNotConnected: "❌ Utente non connesso",
      testing: "🧪 Test in corso...",
      success: "✅ Test riuscito",
      error: "❌ Errore",
      unknownError: "Errore sconosciuto",
    },
    instructions: {
      title: "📋 Istruzioni",
      step1: "Clicca su \"Testa Funzione Firebase\" sopra",
      step2: "Se il test ha successo, vai su Impostazioni → Account",
      step3: "Prova a eliminare il tuo account",
      step4: "La funzione backend dovrebbe funzionare senza richiedere password",
    },
    messages: {
      eventCreated: "✅ Evento creato con successo! ID: {{eventId}}",
      tasksGenerated: "🎯 {{count}} attività generate automaticamente!",
      noTasksFound: "⚠️ Nessuna attività trovata. Usa il pulsante di debug per generare manualmente.",
      errorLoadingTasks: "❌ Errore nel caricamento delle attività",
      errorCreatingEvent: "❌ Errore",
      waitingForTasks: "🔄 Attesa di 3 secondi prima di caricare le attività...",
      loadingTasks: "🔍 Caricamento attività per l'evento:",
      tasksReloaded: "🔄 Ricaricato: {{count}} attività trovate",
      errorReloadingTasks: "❌ Errore nel ricaricare le attività",
      debuggingGeneration: "🔧 Debug della generazione attività...",
      manualGenerationComplete: "✅ Generazione manuale completata",
      debugError: "❌ Errore di debug",
      testingExistingEvent: "🧪 Test con evento esistente...",
      eventNotFound: "❌ Evento non trovato",
      eventFound: "📋 Evento trovato",
      eventDate: "📅 Data",
      eventCountry: "🌍 Paese",
      notSpecified: "Non specificato",
      existingTasks: "📊 Attività esistenti",
      generatingTasks: "🔧 Generazione attività (se necessario)...",
      generationComplete: "✅ Generazione completata",
      newTasks: "📊 Nuove attività",
      testError: "❌ Errore di test",
      generatingForAllEvents: "🔄 Generazione attività per tutti gli eventi esistenti...",
      noEventsFound: "📋 Nessun evento trovato",
      eventsFound: "📊 {{count}} evento/i trovato/i",
      processingEvent: "🔧 Elaborazione",
      generatingTasksFor: "🎯 Generazione attività per",
      tasksGeneratedFor: "✅ {{count}} attività generate per",
      eventAlreadyHasTasks: "✅ {{name}} ha già {{count}} attività",
      errorProcessingEvent: "❌ Errore per",
      processingComplete: "🎉 Elaborazione completata: {{processed}} eventi elaborati, {{generated}} nuove attività generate",
      globalError: "❌ Errore globale",
    },
    eventTypes: {
      wedding: "Matrimonio",
      birthday: "Compleanno",
      engagement: "Fidanzamento",
      babyShower: "Baby Shower",
      baptism: "Battesimo",
      other: "Altro",
    },
  },
  
  eventForm: {
    title: "Dettagli dell'evento",
    name: "Nome dell'evento",
    description: "Descrizione",
    date: "Data",
    time: "Ora",
    location: "Luogo",
    type: "Tipo di evento",
    guests: "Numero stimato di ospiti",
    budget: "Budget stimato",
    notes: "Note",
    submit: "Crea evento",
    cancel: "Annulla",
    edit: "Modifica",
    delete: "Elimina",
    partner1: "Partner 1",
    partner2: "Partner 2",
    firstName: "Nome",
    lastName: "Cognome"
  },
  
  messages: {
    createSuccess: "Evento creato con successo",
    updateSuccess: "Evento aggiornato con successo",
    deleteSuccess: "Evento eliminato con successo",
    deleteConfirm: "Sei sicuro di voler eliminare questo evento?",
    error: "Si è verificato un errore",
    eventUpdated: "Evento aggiornato con successo",
    eventDeleted: "Evento eliminato con successo",
    updateError: "Errore nell'aggiornamento",
    deleteError: "Errore nell'eliminazione",
    invalidDate: "Data non valida"
  },
  
  eventActions: {
    view: "Visualizza",
    edit: "Modifica",
    delete: "Elimina",
    duplicate: "Duplica",
    share: "Condividi",
    setDefault: "Imposta come predefinito"
  },
  
  validation: {
    accountHealth: 'Stato dell\'account',
    problemsDetected: 'Problemi rilevati con i tuoi eventi',
    suggestions: 'Suggerimenti',
    cannotCreate: 'Impossibile creare un nuovo evento',
    cannotDelete: 'Impossibile eliminare l\'evento',
    limitReached: 'Limite di eventi raggiunto',
    multipleEventsNotAllowed: 'Il tuo abbonamento non consente più eventi',
    cannotDeleteDefault: 'Impossibile eliminare l\'evento predefinito',
    cannotDeleteLast: 'Impossibile eliminare l\'ultimo evento',
    duplicateFound: 'Esiste già un evento simile',
    continueAnyway: 'Vuoi continuare?',
    upgradeRequired: 'Aggiornamento richiesto',
    noEventsFound: 'Nessun evento trovato',
    noDefaultEvent: 'Nessun evento predefinito definito',
    multipleDefaultEvents: 'Più eventi definiti come "predefiniti"',
    eventsWithoutName: 'evento/i senza nome',
    healthyAccount: 'Account in buona salute',
    setAnotherAsDefault: 'Imposta prima un altro evento come evento predefinito',
    createBeforeDelete: 'Crea un nuovo evento prima di eliminare questo'
  },
  
  faq: {
    convertEvent: {
      question: "Come convertire un evento in un tipo specifico?",
      answer: "Puoi cambiare il tipo di evento nelle impostazioni. Questo adatterà automaticamente le funzionalità disponibili."
    }
  }
};
